'use client';
import { useState, useEffect, useRef } from 'react';

const stats = [
  { icon: 'fas fa-heartbeat', number: '70+', label: 'Ans d\'Expérience' },
  { icon: 'fas fa-user-md', number: '8', label: 'Spécialités Médicales' },
  { icon: 'fas fa-building', number: '2', label: 'Groupes Partenaires' },
  { icon: 'fas fa-map-marker-alt', number: '1', label: 'Centre à Ananeraie' },
];

export default function StatisticsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <div
      id="statistic-1"
      ref={ref}
      style={{ background: 'linear-gradient(135deg, #0e5932 0%, #1a8a4a 100%)' }}
      className="py-20"
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats?.map((stat, i) => (
            <div
              key={i}
              className="text-center transition-all duration-700"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(20px)',
                transitionDelay: `${i * 150}ms`,
              }}
            >
              <div className="text-5xl mb-4" style={{ color: 'rgba(255,255,255,0.6)' }}>
                <i className={stat?.icon}></i>
              </div>
              <div
                className="text-4xl md:text-5xl font-black text-white mb-2"
                style={{ fontFamily: 'Lato, sans-serif' }}
              >
                {stat?.number}
              </div>
              <p className="text-sm font-medium" style={{ color: 'rgba(255,255,255,0.8)' }}>
                {stat?.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
